export default __webpack_public_path__ + "static/media/analyseLogo.ea4e7c64.webp";